import { useMemo } from 'react'
import { IntegrationServiceId } from '../../common/integrations'
import { IntegrationRequirementMessage } from '../../common/IntegrationRequirementMessage'
import { useIntegrationRequirement } from '../../common/useIntegrationRequirement'
import { parseMetadata } from '../../common/util'
import { RoomSession } from '../../models/Room'
import { SelectDropdownProps } from '../SelectDropdown/SelectDropdown'

export function useAutoJoinMissingIntegrationOptions(roomSession: RoomSession): SelectDropdownProps['options'] | undefined {
  const { source } = parseMetadata(roomSession.metadata)
  const checkRequirement = useIntegrationRequirement()
  const serviceId = source as IntegrationServiceId
  const { satisfied } = checkRequirement(serviceId)

  return useMemo(() => {
    if (satisfied) {
      return undefined
    }
    return [
      {
        id: 'false',
        label: `Can't join`,
        displayLabel: (
          <div className='paragraph-small'>
            <IntegrationRequirementMessage serviceId={serviceId} />
          </div>
        ),
      },
    ]
  }, [serviceId, satisfied])
}
